
  export const formateBusesBusidasKey=(busesData)=>{
    let formatedData={};
    busesData.forEach((row)=>{
      formatedData[row.id]=row;
    })
    return formatedData;
  }
